// extracted by mini-css-extract-plugin
export default {"productGrid":"D0-z","centerLink":"E0-z","productSection":"F0-z","item":"G0-z","ctaButton":"H0-z"};